import React, { useEffect, useState } from "react";
import DashboardHeader from "../components/DashboardHeader";
import { FolderKanban, CheckCircle2, ThumbsUp, FileText } from "lucide-react";

export default function ProiecteAprobate({ memberData }) {
  const [proiecte, setProiecte] = useState([]);
  const [voturiSet, setVoturiSet] = useState(new Set());
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const token = "unwantedtok";

  useEffect(() => {
    async function loadData() {
      if(!memberData?.id) return;
      setLoading(true);
      setError(null);
      try {
        const [proiecteRes, voturiRes] = await Promise.all([
          fetch("https://prdp-api.suport-949.workers.dev/api/proiecte-aprobate", {
            headers: { Authorization: `Bearer ${token}` },
          }),
          fetch(
            `https://prdp-api.suport-949.workers.dev/api/voturi-proiecte?id_membru_votant=${memberData.id}`,
            {
              headers: { Authorization: `Bearer ${token}` },
            }
          ),
        ]);

        if (!proiecteRes.ok) throw new Error("Eroare la încărcarea proiectelor propuse.");
        if (!voturiRes.ok) throw new Error("Eroare la încărcarea voturilor.");

        const proiecteData = await proiecteRes.json();
        const voturiData = await voturiRes.json();

        setProiecte(proiecteData);
        setVoturiSet(new Set(voturiData.map((v) => v.id_proiect)));
      } catch (err) {
        setError(err.message || "Eroare la încărcarea datelor.");
      } finally {
        setLoading(false);
      }
    }
    loadData();
  }, [memberData]);

  async function voteaza(idProiect) {
    try {
      const res = await fetch("https://prdp-api.suport-949.workers.dev/api/voturi-proiecte", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          id_proiect: idProiect,
          id_membru_votant: memberData.id,
          nume_votant: memberData.nume,
          prenume_votant: memberData.prenume,
        }),
      });
      if (!res.ok) {
        const data = await res.json();
        throw new Error(data.error || "Eroare la votare.");
      }
      setVoturiSet(new Set([...voturiSet, idProiect]));
    } catch (err) {
      alert(err.message);
    }
  }

  return (
    <div className="dashboard-wrapper" style={{ overflowX: "hidden", minHeight: "100vh", backgroundColor: "#0b1120", paddingBottom: "60px" }}>
      <DashboardHeader user={memberData} />
      
      <div style={{ maxWidth: "800px", margin: "40px auto", padding: "0 20px" }}>
        
        <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "32px", justifyContent: "center" }}>
          <FolderKanban size={32} color="#fbbf24" />
          <h2 style={{ color: "#f8fafc", fontWeight: 800, margin: 0, fontSize: "2rem", letterSpacing: "-0.5px" }}>
            Proiecte în dezbatere
          </h2>
        </div>

        {loading && <p style={{ textAlign: "center", color: "#94a3b8", fontStyle: "italic" }}>Se încarcă proiectele...</p>}
        {error && <p style={{ color: "#ef4444", textAlign: "center", backgroundColor: "rgba(239, 68, 68, 0.1)", padding: "12px", borderRadius: "12px" }}>{error}</p>}
        
        {!loading && !error && proiecte.length === 0 && (
          <div style={{ textAlign: "center", padding: "40px", backgroundColor: "#1e293b", borderRadius: "24px", border: "1px solid rgba(255, 255, 255, 0.05)" }}>
            <FileText size={48} color="#64748b" style={{ marginBottom: "16px" }} />
            <p style={{ color: "#94a3b8", fontSize: "1.1rem" }}>Momentan nu există proiecte noi în dezbatere.</p>
          </div>
        )}

        {!loading && !error && proiecte.length > 0 && (
          <div style={{ display: "flex", flexDirection: "column", gap: "24px" }}>
            {proiecte.map((proiect) => {
              const dejaVotat = voturiSet.has(proiect.id);
              return (
                <div 
                  key={proiect.id} 
                  style={{
                    backgroundColor: "#1e293b",
                    borderRadius: "24px",
                    padding: "32px",
                    border: "1px solid rgba(255, 255, 255, 0.05)",
                    boxShadow: "0 10px 25px -5px rgba(0, 0, 0, 0.3)",
                    transition: "transform 0.2s ease",
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.transform = "translateY(-4px)"}
                  onMouseLeave={(e) => e.currentTarget.style.transform = "translateY(0)"}
                >
                  <h3 style={{ fontWeight: 700, fontSize: "1.35rem", color: "#f8fafc", marginBottom: "12px", lineHeight: "1.3" }}>
                    {proiect.titlu}
                  </h3>
                  
                  <p style={{ fontWeight: 600, fontSize: "1.05rem", color: "#fbbf24", marginBottom: "16px" }}>
                    {proiect.descriere_scurta}
                  </p>
                  
                  {proiect.descriere_lunga && (
                    <p style={{ fontSize: "0.95rem", color: "#cbd5e1", whiteSpace: "pre-wrap", marginBottom: "24px", lineHeight: "1.6" }}>
                      {proiect.descriere_lunga}
                    </p>
                  )}
                  
                  <div style={{ borderTop: "1px solid rgba(255, 255, 255, 0.05)", paddingTop: "24px", marginTop: "12px", display: "flex", justifyContent: "flex-end" }}>
                    <button
                      disabled={dejaVotat}
                      onClick={() => voteaza(proiect.id)}
                      style={{
                        padding: "12px 24px",
                        fontSize: "1rem",
                        fontWeight: 700,
                        borderRadius: "12px",
                        border: "none",
                        cursor: dejaVotat ? "default" : "pointer",
                        transition: "all 0.2s ease",
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        backgroundColor: dejaVotat ? "rgba(16, 185, 129, 0.1)" : "#fbbf24",
                        color: dejaVotat ? "#10b981" : "#0f172a",
                      }}
                      onMouseEnter={(e) => {
                        if (!dejaVotat) e.currentTarget.style.backgroundColor = "#f59e0b";
                      }}
                      onMouseLeave={(e) => {
                        if (!dejaVotat) e.currentTarget.style.backgroundColor = "#fbbf24";
                      }}
                    >
                      {dejaVotat ? (
                        <><CheckCircle2 size={20} /> Ai votat pentru acest proiect</>
                      ) : (
                        <><ThumbsUp size={20} /> Susține proiectul</>
                      )}
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
